import moment from 'moment-timezone';
import { getUserSystemTimezone } from './getUserSystemTimezone';

/**
 * Returns user's system timezone if it's a US timezone, otherwise empty string.
 * For forms where non-US users should select timezone manually.
 */
export const getDefaultFormTimezone = <T extends '' | null>(
  emptyValue: T,
): string | T => {
  const systemTz = getUserSystemTimezone();
  const usZones = moment.tz.zonesForCountry('US') || [];
  return usZones.includes(systemTz) ? systemTz : emptyValue;
};
